import type { UserPermissionAction, UserPermissionType } from "avvir";
import { immerable } from "immer";

type UserPermissionArgument = Partial<UserPermission> & {
  firebaseProjectId?: string
  firebaseOrganizationId?: string
}

export default class UserPermission {
  constructor({
    id,
    userId,
    projectId,
    organizationId,
    firebaseProjectId,
    firebaseOrganizationId,
    masterformatCode,
    permissionType,
    permissionAction,
    workPackageId
  }: UserPermissionArgument) {
    this.id = id;
    this.userId = userId;
    this.projectId = projectId || firebaseProjectId;
    this.organizationId = organizationId || firebaseOrganizationId;
    this.masterformatCode = masterformatCode;
    this.permissionType = permissionType;
    this.permissionAction = permissionAction;
    this.workPackageId = workPackageId;
  }

  readonly id: number;
  readonly userId: number;
  readonly projectId: string;
  readonly organizationId: string;
  readonly masterformatCode: string;
  readonly permissionType: UserPermissionType;
  readonly permissionAction: UserPermissionAction;
  readonly workPackageId: number;
  private static readonly [immerable] = true;
}
